import { supabaseClient } from "@/lib/supabase";

export async function getMfaState() {
    const [{ data: assurance, error: assuranceError }, { data: factors, error: factorsError }] = await Promise.all([
        supabaseClient.auth.mfa.getAuthenticatorAssuranceLevel(),
        supabaseClient.auth.mfa.listFactors(),
    ]);
    if (assuranceError) throw assuranceError;
    if (factorsError) throw factorsError;

    return {
        currentLevel: assurance.currentLevel,
        nextLevel: assurance.nextLevel,
        verifiedTotp: factors.totp.filter((factor) => factor.status === "verified"),
    };
}

export async function enrollTotp() {
    const { data: factors, error: factorsError } = await supabaseClient.auth.mfa.listFactors();
    if (factorsError) throw factorsError;
    for (const factor of factors.all.filter(
        (candidate) => candidate.factor_type === "totp" && candidate.status === "unverified"
    )) {
        const { error } = await supabaseClient.auth.mfa.unenroll({ factorId: factor.id });
        if (error) throw error;
    }
    const { data, error } = await supabaseClient.auth.mfa.enroll({ factorType: "totp" });
    if (error) throw error;
    return data;
}

export async function verifyTotp(factorId: string, code: string) {
    const { data: challenge, error: challengeError } = await supabaseClient.auth.mfa.challenge({ factorId });
    if (challengeError) throw challengeError;
    const { error: verifyError } = await supabaseClient.auth.mfa.verify({
        factorId,
        challengeId: challenge.id,
        code,
    });
    if (verifyError) throw verifyError;
    const { data, error } = await supabaseClient.auth.refreshSession();
    if (error) throw error;
    const { data: assurance, error: assuranceError } = await supabaseClient.auth.mfa.getAuthenticatorAssuranceLevel();
    if (assuranceError) throw assuranceError;
    if (assurance.currentLevel !== "aal2") throw new Error("Multi-factor authentication could not be confirmed.");
    return data.session;
}

export async function removeTotp(factorId: string) {
    const { error } = await supabaseClient.auth.mfa.unenroll({ factorId });
    if (error) throw error;
    const { error: refreshError } = await supabaseClient.auth.refreshSession();
    if (refreshError) throw refreshError;
}
